import React from "react";
import {
  Dashboard
} from "../containers";

export function DashboardPage() {
  return <Dashboard />;
}
